export const AnimationStates = {
  ENTERING: 'entering',
  EXITING: 'exiting',
};
